export default "__VITE_ASSET__83b401f8__"